import React, { Component } from "react";
import "./App.css";
import Header from './Components/Header'
import Footer from './Components/Footer'
import {
	BrowserRouter,
	Switch,
	Route,
	Redirect
} from "react-router-dom";
import Home from "./Pages/Home.js";
import Inspection from "./Pages/Inspection.js"
import { animateScroll as scroll } from "react-scroll";
import PastProjects from "./Pages/PastProjects";
import Contact from "./Pages/Contact.js"


class App extends Component {
	state = { language: "CN" }
	
	changeLanguage = (language) => this.setState(({ language }))
	
	scrollToTop = () => {
		scroll.scrollToTop();
	};

	render() {

		return (
			<BrowserRouter>
				<div className="App">
					<Header changeLanguage={this.changeLanguage} language={this.state.language}/>
					<Switch>
						<Route exact path="/">
							<Home language={this.state.language} />
						</Route>
						<Route exact path="/inspection-flow">
							<Inspection language={this.state.language} />
						</Route>
						<Route exact path="/past-projects">
							<PastProjects language={this.state.language} />
						</Route>
						<Route exact path="/contact">
							<Contact language={this.state.language} />
						</Route>
						<Route path="*" render={() => <Redirect to="/" />} />
					</Switch>
					<Footer language={this.state.language}/>
				</div>
			</BrowserRouter>
		);
	}
}

export default App;
